import { render, staticRenderFns } from "./add.vue?vue&type=template&id=977f9226&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=977f9226&prod&lang=css&scoped=true"
import style1 from "./add.vue?vue&type=style&index=1&id=977f9226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977f9226",
  null
  
)

export default component.exports